import './LuckyWheel.less';
import React, { useEffect } from 'react';
import luckyWheelSmallIcon from './images/lucky-wheel-small-icon.png';
import CloseIcon from '../../icons/CloseIcon';
import i18n from '../../common/i18n';
import {
    closeLuckyWheelNotification,
    luckyWheelSubscription$,
    setLuckyWheelIdIntoLocalStorage,
    showLuckyWheelNotification$
} from './h&s';
import { dispatch, useReframe } from 'nike-re-framejs';
import clsx from 'clsx';
import { useActiveRoute } from '../../common/routing/NikeRouteContext';

const LuckyWheelNotificationToast = ({ onNotificationClick, main = false }) => {
    const { subscribe } = useReframe();
    const showLuckyWheelNotification = subscribe(showLuckyWheelNotification$);
    const lwOffer = subscribe(luckyWheelSubscription$);
    const lwNotifyClient = lwOffer?.offer?.notifyClient;
    const route = useActiveRoute();
    const onDesktopCasino = main && route?.path.includes('/casino');

    const handleClose = e => {
        e?.stopPropagation();
        dispatch(closeLuckyWheelNotification);
    };

    useEffect(() => {
        if (showLuckyWheelNotification) {
            dispatch(setLuckyWheelIdIntoLocalStorage);
            setTimeout(() => handleClose(), 5000);
        }
    }, [showLuckyWheelNotification]);

    return showLuckyWheelNotification && lwNotifyClient === 1 ? (
        <div
            className={clsx('lucky-wheel-notification-container full-width p-fix pt-10', {
                portal: onDesktopCasino || main,
                'p-abs': onDesktopCasino || main
            })}
        >
            <div
                className={clsx('lucky-wheel-notification', { main: main, casino: onDesktopCasino })}
                onClick={onNotificationClick}
            >
                <div className="flex flex-col">
                    <h2>{i18n('luckyWheel.notification.title')}</h2>
                    <span>{i18n('luckyWheel.notification.subtitle')}</span>
                </div>
                <img src={luckyWheelSmallIcon} alt="lucky-wheel-small-icon" width="58px" height="60px" />
                <CloseIcon onClick={e => handleClose(e)} />
                <div className="notification-popup-progress p-abs flex full-width">
                    <div className="lucky-wheel-notification-popup-progress-bar flex" />
                </div>
            </div>
        </div>
    ) : null;
};

export default LuckyWheelNotificationToast;
